import { render, staticRenderFns } from "./currentPatient.vue?vue&type=template&id=5f25fefb&scoped=true&"
import script from "./currentPatient.vue?vue&type=script&lang=js&"
export * from "./currentPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f25fefb",
  null
  
)

export default component.exports